<div class="action-form">
  <span class="title">{{ 'RENTAL_OBJECT.COPY_ROOMS_HEADER' | translate }}</span>
  <div class="desc">{{ 'RENTAL_OBJECT.COPY_ROOMS_DESCRIPTION' | translate }}</div>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row form-group">
        <div class="col-12">
          <app-autocomplete-remote
            [service]="dwellingAutoCompleteService"
            [defaultSearch]="''"
            [control]="form.controls['rentalObjectId']"
          ></app-autocomplete-remote>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12">
          <app-toogle [control]="form.controls['overwrite']"></app-toogle>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12">
          <button class="btn btn-active" type="submit">{{ 'OK_BTN' | translate }}</button>
          <button class="btn link-btn ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
        </div>
      </div>
    </form>
  }
</div>
